<template>
  <div class="home" v-loading="loading">
    <div class="flex al-cn ju-sp war-pe mb20 head">
      <swiper
          id="swiperBox"
          :class="token ? 'swiper1' : 'swiper'"
          :options="swiperOption"
          ref="mySwiper">
        <swiper-slide v-for="(item,index) in swiperList" :key="index">
          <img :src="item.image" style="object-fit: cover;"/>
        </swiper-slide>
      </swiper>
      <logIn v-if="!token" class="logIn" :name="name"/>
    </div>
    <div class="flex al-cn ju-sp war-pe">
      <div
          class="queryMenu flex al-cn ju-cn pointer mb20 card-shadow"
          @click="routerGo(item.path)"
          v-for="(item,index) in queryList"
          :key="index">
        <img class="queryMenu-img" :src="item.img"/>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div class="flex ju-sp war-pe">
      <cardData class="mb20 data1" title="考试通知" :list="examinationAnnouncement" path="/latestNews/examNotice/list"/>
      <cardData class="mb20 data1" title="新闻资讯" :list="newsInformation" path="/latestNews/newsInformation/list"/>
    </div>
    <div class="flex ju-sp war-pe">
      <cardData
          class="mb20 data2"
          title="实习实践项目"
          :list="overseasInternship"
          path="/internship/overseasInternship/list"/>
      <cardData
          class="mb20 data2"
          title="实习实践动态"
          :list="internationalChinese"
          path="/internship/internationalChinese/list"/>
      <cardData
          class="mb20 data2"
          title="就业及升学"
          :list="employmentAndPromotion"
          path="/internship/employment/list"/>
    </div>
    <div class="flex ju-sp war-pe aboutUs">
      <div class="p20 su-card mb20 aboutUs-left">
        <su-title title="关于我们" @discolour="routerGo('/aboutUs')"/>
        <img class="mb20 aboutUs-left-img" :src="aboutUs.image || require('@/assets/slices/Group10.png')"/>
        <div class="cl333 f14 indent2 aboutUs-left-description">
          <div v-html="aboutUs.content"></div>
        </div>
      </div>
      <div class="p20 su-card mb20 aboutUs-right">
        <div @click="routerGo('/aboutUs/examPoint')">
          <img class="card-shadow" src="@/assets/slices/Group11.png"/>
        </div>
        <div @click="routerGo('/latestNews/cooperation')">
          <img class="card-shadow mtb10" src="@/assets/slices/Group15.png"/>
        </div>
        <div @click="routerGo('/aboutUs/complaint')">
          <img class="card-shadow" src="@/assets/slices/Group16.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";
import logIn from "@/views/Login/index.vue"
import CardData from "@/components/cardData/cardData.vue";
import {getNewsList, getUserInfo, postHome} from "@/api/api";
import {mapState} from 'vuex'

export default {
  name: "HelloWorld",
  components: {
    CardData,
    swiper,
    swiperSlide,
    logIn
  },
  data() {
    return {
      loading: false,
      //查询列表
      queryList: [
        {
          name: '考试报名',
          img: require('@/assets/slices/kaoshibaoming.png'),
          path: '/examinationAndRegistration/signUp'
        },
        {
          name: '成绩查询',
          img: require('@/assets/slices/chengjichaxun.png'),
          path: '/examinationAndRegistration/scoreInquiry'
        },
        {
          name: '考点查询',
          img: require('@/assets/slices/tu-22.png'),
          path: '/examinationAndRegistration/testSiteQuery'
        },
        {
          name: '证书查询',
          img: require('@/assets/slices/a-iconzigezhengshu.png'),
          path: '/examinationAndRegistration/certificateQuery'
        },
      ],
      // 考试公告
      examinationAnnouncement: [],
      //新闻资讯
      newsInformation: [],
      // 海外实习实践基地
      overseasInternship: [],
      //国际中文传播实习
      internationalChinese: [],
      //就业及升学
      employmentAndPromotion: [],
      // 轮播图数据
      swiperList: [],
      //轮播图配置
      swiperOption: {
        // 自动切换
        autoplay: {
          // 停留时间
          delay: 3000,
          // 用户操作swiper之后，是否禁止autoplay
          disableOnInteraction: false,
        },
        pagination: true, //分页器
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        on: {} //事件监听
      },
      //关于我们
      aboutUs: {},
      name: '',
    };
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    ...mapState(['token', 'userInfo']),
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  watch: {
    // 监听路由的变化
    $route(val) {
      //如果路径发生变化,则获取当前路由带过来的参数
      this.name = val.query.name
    }
  },
  created() {
    //路由参数
    this.name = this.$route.query.name
    this.postHome()
    //用户信息
    if (this.token) {
      this.getUserInfo()
      console.log('userInfo', this.userInfo)
    }
  },
  mounted() {
    this.fetchNews();
  },
  methods: {
    async fetchNews() {
      try {
        this.employmentAndPromotion = await this.getNewsList('25'); // 就业及升学
        this.internationalChinese = await this.getNewsList('24'); // 国际中文传播实习
        this.overseasInternship = await this.getNewsList('23'); // 海外实习实践基地
      } catch (error) {
        console.error('Error fetching news:', error);
      }
    },
    // 新闻列表
    async getNewsList(id) {
      try {
        const response = await getNewsList({page: 1, size: 10, cate_id: id});
        if (response.status === 200) {
          return response.data.data || [];
        } else {
          console.error('Failed to fetch news list:', response);
          return [];
        }
      } catch (error) {
        console.error('Error fetching news list:', error);
        return [];
      }
    },
    // 用户信息
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.status === 200) {
          let userInfo = res.data || {}
          this.$store.commit('setUserInfo', userInfo)
        }
      })
    },
    // 首页
    postHome() {
      postHome().then(res => {
        if (res.status === 200) {
          this.newsInformation = res.data.news.data  //新闻资讯
          this.examinationAnnouncement = res.data.announcement.data //考点公告
          this.aboutUs = res.data.about //关于我们
          this.swiperList = res.data.top
        }
      })
    },
    // 路由跳转
    routerGo(path) {
      if (path && path !== this.$route.fullPath) {
        this.$router.push({path: path});
      }
    },
    // 登录
    loginIn() {
      this.$router.push({path: "/login"});
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  //font-family: PingFangSC, PingFang SC;
}

.queryMenu {
  width: calc(25% - 15px);
  height: 100px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;

  &-img {
    width: 50px;
    height: 50px;
    padding-right: 15px;
  }
}

.swiper img {
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 10px 10px;
}

.swiper1 img {
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 10px 10px;
}

.aboutUs {

  &-left {
    width: calc(65% - 27px);

    &-img {
      width: 100%;
    }

    &-description {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      white-space: normal;
    }
  }

  &-right {
    width: calc(30% - 14px);

    img {
      width: 100%;
      height: 100%;
    }
  }
}

@media (max-width: 750px) {
  .swiper {
    width: 100%;
    height: 225px;
  }
  .logIn {
    width: 100%;
  }
  .queryMenu {
    width: calc(50% - 10px);
    height: 70px;

    &-img {
      width: 40px;
      height: 40px;
    }
  }
  .data1 {
    width: 100%;
  }
  .data2 {
    width: 100%;
  }
  .aboutUs {
    &-left {
      width: 100%;
    }

    &-right {
      width: 100%;
    }
  }
}

@media (min-width: 750px) {
  .swiper {
    width: calc(64% - 30px);
    height: 425px;
  }
  .swiper1 {
    width: 100%;
    height: 425px;
  }
  .logIn {
    width: calc(30% - 30px);
  }
  .data1 {
    width: calc(50% - 11px);
  }
  .data2 {
    width: calc(33.3% - 12px);
  }
}
</style>
